'use strict';
import '../../style/footer.css';
import React from 'react';
import FooterNavigation from './footer_navigation';

const Footer = props => (
    <FooterNavigation/>
);

export default Footer;